/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type PendingReviewTypeEnum =
  (typeof PendingReviewTypeEnum)[keyof typeof PendingReviewTypeEnum];

export const PendingReviewTypeEnum = {
  owner: 'owner',
  pet: 'pet',
} as const;
